module.exports = __webpack_public_path__ + "elephant-friend-1-18bbe5bf56bcd2f550f26ae91be00dfb.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/elephant-friend-1.png
// module id = 196
// module chunks = 64